import "./Fretboards.scss";

import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Fretboard from "./Fretboard";
import AudioKey from "../../lib/AudioKey";
import { fretboardConfigs } from "../../lib/fretboards";
import { getKeyByNumericKey, getRelativeKey } from "../../lib/audioTools";

class Fretboards extends PureComponent {
	static propTypes = {
		fretboardConfig: PropTypes.number,
		highlight: PropTypes.number,
		orientation: PropTypes.string,
		relativeKey: PropTypes.instanceOf(AudioKey),
		selectedKey: PropTypes.instanceOf(AudioKey),
		stringLayout: PropTypes.string
	};

	render() {
		let {
			fretboardConfig = 0,
			highlight,
			orientation,
			relativeKey,
			selectedKey,
			stringLayout
		} = this.props;

		let { fretboards } = fretboardConfigs[fretboardConfig];

		return (
			<div className="fretboards">
				{ fretboards.map(({ dots, frets, instrument, strings, title }, index) => (
					<Fretboard
						dots={dots}
						frets={frets}
						highlight={highlight}
						instrument={instrument}
						orientation={orientation}
						relativeKey={relativeKey}
						selectedKey={selectedKey}
						stringLayout={stringLayout}
						strings={strings}
						title={title}
						key={index} />
				)) }
			</div>
		);
	}
}

const mapStateToProps = function(state) {
	let {
		meta: {
			fretboardConfig,
			highlight,
			orientation,
			selectedKey,
			stringLayout
		}
	} = state;

	let key = getKeyByNumericKey(selectedKey);

	return {
		fretboardConfig,
		highlight,
		orientation,
		relativeKey: key && getRelativeKey(key),
		selectedKey: key,
		stringLayout
	};
};

export default connect(mapStateToProps)(Fretboards);
